import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AdminUpdateUserRequest,
  ChangePasswordRequest,
  UpdateProfileRequest,
  UserProfileDto
} from '../models/user-profile.model';

/**
 * User profile & directory APIs (adjust paths to match your Spring controllers).
 *
 * - GET/PUT `/api/v1/users/me` — current user profile
 * - POST `/api/v1/users/me/password` — change password `{ currentPassword, newPassword }`
 * - GET `/api/v1/users` — list users (admin, tenant-scoped on server)
 * - PUT `/api/v1/users/{id}` — admin update user
 */
@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  private readonly usersBase = `${environment.apiUrl}/api/v1/users`;

  constructor(private http: HttpClient) { }

  getMyProfile(): Observable<UserProfileDto> {
    return this.http.get<UserProfileDto>(`${this.usersBase}/me`);
  }

  updateMyProfile(body: UpdateProfileRequest): Observable<UserProfileDto> {
    return this.http.put<UserProfileDto>(`${this.usersBase}/me`, body);
  }

  changeMyPassword(body: ChangePasswordRequest): Observable<void> {
    return this.http.post<void>(`${this.usersBase}/me/password`, body);
  }

  listUsers(): Observable<UserProfileDto[]> {
    return this.http.get<UserProfileDto[]>(this.usersBase);
  }

  updateUser(id: number, body: AdminUpdateUserRequest): Observable<UserProfileDto> {
    return this.http.put<UserProfileDto>(`${this.usersBase}/${id}`, body);
  }
}
